export default __webpack_public_path__ + "static/media/faq1.895c635d.svg";